import { create } from 'zustand';

import { FAQsPropertyItem } from '@mygpt/app';

interface FAQsPropertyStore {
  records: Record<string, FAQsPropertyItem[]>;
  cacheTotal: Record<string, number>;

  all: Record<string, FAQsPropertyItem[]>;
}

export const faqsPropertyStore = create<FAQsPropertyStore>(() => ({
  records: {},
  cacheTotal: {},
  all: {},
}));

export type FAQsPropertyStoreDataType = 'all' | 'records';

export const appendFAQsPropertyStore = (
  datasetId: string,
  type: FAQsPropertyStoreDataType,
  ...items: FAQsPropertyItem[]
) => {
  const data = faqsPropertyStore.getState()[type][datasetId] ?? [];
  const newData = [...items, ...data];
  faqsPropertyStore.setState({
    [type]: {
      [datasetId]: newData,
    },
  });
  if (type === 'records') {
    faqsPropertyStore.setState({
      cacheTotal: {
        [datasetId]: (faqsPropertyStore.getState().cacheTotal[datasetId] ?? 0) + 1,
      },
    });
  }
};

export const updateFAQsPropertyStore = (datasetId: string, type: FAQsPropertyStoreDataType, item: FAQsPropertyItem) => {
  const data = faqsPropertyStore.getState().records[datasetId] ?? [];
  const newData = data.concat();
  const target = newData.find((_item) => _item.id === item.id);
  if (target) {
    Object.assign(target, item);
    faqsPropertyStore.setState({
      [type]: {
        [datasetId]: newData,
      },
    });
  }
};

export const deleteFAQsPropertyStore = (datasetId: string, type: FAQsPropertyStoreDataType, id: string) => {
  const data = faqsPropertyStore.getState().records[datasetId] ?? [];
  const newData = data.concat();
  const index = newData.findIndex((item) => item.id === id);
  if (index > -1) {
    newData.splice(index, 1);
    faqsPropertyStore.setState({
      [type]: {
        [datasetId]: newData,
      },
    });
    if (type === 'records') {
      faqsPropertyStore.setState({
        cacheTotal: {
          [datasetId]: (faqsPropertyStore.getState().cacheTotal[datasetId] ?? 0) - 1,
        },
      });
    }
  }
};
